import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { SyncProgressEvent } from '../sync-progress-event';

@Injectable()
export class EventStreamService {

  constructor(private http: HttpClient) {
  }

  /**
   * For initial syncs
   */
  getSyncStream(syncUrl: string,
                pollUrl: string): Observable<SyncProgressEvent> {
    return new Observable<SyncProgressEvent>(obs => {
      this.http.get(syncUrl).subscribe(() => {
        const timerSub = timer(5000, 5000).subscribe(() => {
          this.http.get<SyncProgressEvent>(pollUrl).subscribe(event => {
            obs.next(event);
            if (event.done) {
              timerSub.unsubscribe();
              obs.complete();
            }
          });
        });
      });
    });
  }

  /**
   * For when a sync is already running.
   */
  getRunningStream(pollUrl: string): Observable<SyncProgressEvent> {
    return new Observable<SyncProgressEvent>(obs => {
      const timerSub = timer(5000, 5000).subscribe(() => {
        this.http.get<SyncProgressEvent>(pollUrl).subscribe(event => {
          obs.next(event);
          if (event.done) {
            timerSub.unsubscribe();
            obs.complete();
          }
        });
      });
    });
  }

  /**
   * For script
   */
  getScriptStream(scriptPollUrl: string): Observable<void> {
    return new Observable(obs => {
      const timerSub = timer(0, 5000).subscribe(() => {
        this.http.get(scriptPollUrl).subscribe(done => {
          obs.next();
          if (done) {
            timerSub.unsubscribe();
            obs.complete();
          }
        });
      });
    });
  }
}
